// const server = "http://localhost";
// const domain = "localhost";
// const port = 9666;
const serverImg = 'https://solutech.nbg1.your-objectstorage.com/public';
const server = "https://apisolutech.mansolutions.app";
const port = 443;
const domain = "solutech.mansolutions.app";
export { server, port, domain, serverImg };
